module.exports = __webpack_public_path__ + "static/shipkoo-inventory-management-infographics-3490149f04be2cbc825da84fbbc3f044.png";